// Utilitaires pour détecter l'environnement Electron

/**
 * Vérifie si l'application s'exécute dans Electron
 * @returns {boolean}
 */
export const isElectron = () => {
  // Plusieurs méthodes de détection pour plus de robustesse
  return (
    typeof window !== 'undefined' && (
      // Méthode 1: window.process.type === 'renderer'
      (window.process && window.process.type === 'renderer') ||
      // Méthode 2: window.electron existe
      (typeof window.electron !== 'undefined') ||
      // Méthode 3: navigator.userAgent contient Electron
      (navigator.userAgent && navigator.userAgent.toLowerCase().indexOf('electron') !== -1) ||
      // Méthode 4: window.require existe (Electron renderer)
      (typeof window.require !== 'undefined' && window.require.name === 'require')
    )
  );
};

/**
 * Vérifie si l'application s'exécute dans un navigateur
 * @returns {boolean}
 */
export const isBrowser = () => {
  return !isElectron();
};

/**
 * Obtient la version de l'application (si Electron)
 * @returns {string|null}
 */
export const getAppVersion = async () => {
  if (isElectron() && window.electron) {
    try {
      return await window.electron.getAppVersion();
    } catch (error) {
      console.warn('Impossible de récupérer la version:', error);
      return null;
    }
  }
  return null;
};

/**
 * Obtient le chemin des données utilisateur (si Electron)
 * @returns {string|null}
 */
export const getUserDataPath = () => {
  if (isElectron() && window.electron) {
    try {
      return window.electron.getUserDataPath();
    } catch (error) {
      console.warn('Impossible de récupérer le chemin des données:', error);
      return null;
    }
  }
  return null;
};

export default {
  isElectron,
  isBrowser,
  getAppVersion,
  getUserDataPath
};
